import { render, staticRenderFns } from "./MercedesAtegoDashboard.vue?vue&type=template&id=53f0f7e5&"
import script from "./MercedesAtegoDashboard.vue?vue&type=script&lang=js&"
export * from "./MercedesAtegoDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports